<template>
    <user-opt-his 
        ref="list"
        header-text="シェア情報閲覧履歴"
        >
        <div v-if="getListObj">
            <div v-if="getListObj.data.length > 0">
                <div class="card mb-2" @click="showIp = !showIp">
                    <ul class="list-group list-group-flush">
                        <li v-for="item in getListObj.data" :key="item.id" class="list-group-item py-1 let-space-1">
                            <div class="d-flex align-items-center">
                                <span class="text-truncate">
                                    <small>{{item.info_nm}} </small>
                                </span>
                                <span class="flex-fill text-right text-nowrap">
                                    <small>{{item.info_type}} {{item.info_id}} </small>
                                </span>
                            </div>
                            <div class="d-flex">
                                <div>
                                    <small><small class="text-muted">{{item.access_channel}}</small></small>
                                </div>
                                <div class="flex-fill">
                                    <small class="float-right"><small class="text-muted">{{item.created_at | dformatm}}</small></small>
                                </div>
                            </div>
                            <div v-show="showIp" class="text-muted">
                                <hr class="my-2">
                                <div v-if="item.access_id">
                                    <small>
                                        <div>{{item.access_id}}&nbsp;/&nbsp;{{item.access_group}}</div>
                                        <div>{{item.access_nm}}</div>
                                    </small>
                                </div>
                                <div v-else class="text-center"><small>アクセス情報はありません</small></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </user-opt-his>
</template>

<script>
    import UserOptHis from 'pages/commons/List/List'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            UserOptHis
        },
        mounted () {
            this.$refs.list.loadListObj({
                url: 'setting.share.access.his'
            })
        },
        data () {
            return {
                showIp: false
            }
        },
        computed: {
            ...mapGetters(['getListObj'])
        },
    }
</script>
